const isProduction = process.env.NODE_ENV === 'production';

class Logger {
  static log(message, ...args) {
    if (!isProduction) {
      console.log(message, ...args);
    }
  }

  static info(message, ...args) {
    if (!isProduction) {
      console.info(`ℹ️ ${message}`, ...args);
    }
  }

  static warn(message, ...args) {
    if (!isProduction) {
      console.warn(`⚠️ ${message}`, ...args);
    }
  }

  static error(message, ...args) {
    // Error'ları her zaman logla
    console.error(`❌ ${message}`, ...args);
  }

  static debug(message, ...args) {
    if (!isProduction) {
      console.debug(`🐛 ${message}`, ...args);
    }
  }

  static success(message, ...args) {
    if (!isProduction) {
      console.log(`✅ ${message}`, ...args);
    }
  }

  // Production'da da loglanması gereken önemli mesajlar için
  static important(message, ...args) {
    console.log(`🔔 ${message}`, ...args);
  }
}

export default Logger;




























